<template>
    <card-list-item @click="$emit('click')" :class="{'active': active, 'unprocessed': isUnprocessed}">
        <template v-slot:icon>
            <i class="fa-fw" :class="statusIcon"></i>
        </template>
        <template v-slot:content>
            <div class="tile-title">{{fax.file}}</div>
            <div class="meta"><i class="far fa-clock fa-fw mr-2"></i>{{receivedAt}}</div>
            <div class="meta" v-if="ownerLabel"><i class="fas fa-user fa-fw mr-2"></i>{{ownerLabel}}</div>
            <div class="meta" v-if="fax.codes"><i class="fas fa-hashtag fa-fw mr-2"></i>{{fax.codes}}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat" v-if="fax.sort">{{fax.sort}}</span>
                <span class="stat received-via" v-if="fax.received_via">{{fax.received_via}}</span>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from 'moment';

    export default {
        name: 'FaxTile',
        components: {CardListItem},
        props: {
            fax: { type: Object, required: true },
            active: { type: Boolean, default: false }
        },
        computed: {
            isUnprocessed() {
                return !this.fax.processed;
            },
            statusIcon() {
                if (!this.fax.processed) return 'fas fa-circle text-warning';
                return 'fas fa-check-circle text-success';
            },
            receivedAt() {
                return this.fax.timestamp ? moment(this.fax.timestamp).format('MMM D, YYYY h:mm A') : '';
            },
            ownerLabel() {
                if (this.fax.assigned_user) {
                    return `${this.fax.assigned_user.first_name} ${this.fax.assigned_user.last_name}`;
                }
                if (this.fax.code_owner) {
                    return `${this.fax.code_owner.first_name} ${this.fax.code_owner.last_name}`;
                }
                return null;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .unprocessed .tile-title {
        font-weight: bold;
    }
    .received-via {
        text-transform: uppercase;
        font-size: 10px;
        opacity: 0.7;
    }
</style>
